import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DeleteMessageModal } from '../../components/DeleteMessageModal';
import { deleteMessageSelector } from '../../selectors/deleteMessageModalSelector';
import { closeDeleteMessageModal } from '../../slices/deleteMessageSlice';
import { deleteMessage } from '../../thunks/deleteMessage';

export const DeleteMessageModalContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, chatId, messageId, placeType } = useSelector(deleteMessageSelector);

  const onClose = React.useCallback(() => {
    dispatch(closeDeleteMessageModal());
  }, [dispatch]);

  const onDelete = React.useCallback(() => {
    if (!chatId || !messageId || !placeType) {
      return;
    }

    dispatch(deleteMessage({ chatId, messageId, type: placeType }));
  }, [chatId, dispatch, messageId, placeType]);

  if (!isModalOpen) {
    return null;
  }

  return <DeleteMessageModal onClose={onClose} onDelete={onDelete} />;
};
